import React from 'react';

import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import clsx from 'clsx';

import { useNavigationStack } from '../../../../context/NavigationStackContext';
import type { ICommunitiesViewCommunity } from '../../../../redux/api/communities/communities-api.types';
import { AvatarSize, AvatarTypes } from '../../../../shared/constants';
import { Paths } from '../../../../shared/paths';
import AppCommunityAvatar from '../../../designe/app-entity-avatar/app-community-avatar/AppCommunityAvatar';
import CommunityParticipantsCount from '../CommunityParticipantsCount';
import { useStyles } from './CommunitySmallItem.styles';

interface ICommunitySmallItem {
  community: ICommunitiesViewCommunity;
}

export default function CommunitySmallItem(props: ICommunitySmallItem) {
  const { community } = props;
  const theme = useTheme();
  const { classes } = useStyles(theme);
  const { navigate } = useNavigationStack();

  function onCommunityClickHandler() {
    navigate(`${Paths.communities.root}/${community.id}`);
  }

  return (
    <Box
      onClick={() => onCommunityClickHandler()}
      className={clsx(classes.communityWrapper)}>
      <AppCommunityAvatar
        community={community}
        size={AvatarSize.s}
        type={AvatarTypes.round}
      />
      <div className={classes.infoWrapper}>
        <Typography variant="text-lg">{community.title}</Typography>
        {community.participantsCount !== undefined && (
          <CommunityParticipantsCount
            count={community.participantsCount}
            variant="list"
          />
        )}
      </div>
    </Box>
  );
}
